module.exports = __webpack_public_path__ + "assets/img/IndustrialMap.479e2675.png";